export const SELECTOR_ELEMENT_TYPES = {
  typeSelector: 'typeSelector',
  tagSelector: 'tagSelector',
  tagDisplay: 'tagDisplay',
};
